import { ExpandMore } from "@mui/icons-material";
import {
    Box,
    Tab,
    Tabs,
    useMediaQuery,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import { theme } from "app/App";
import React, { Children, useEffect, useState } from "react";

function TabContent({ value, index, children }) {
    return value === index ? children : "";
}

export default function TabContainer({ children, sx, onChangeTab, ...props }) {
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [value, setValue] = useState(0);

    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };

    children = Children.toArray(children);

    const tabs = children.map((child) => child.props.label);

    useEffect(() => {
        if (onChangeTab) onChangeTab(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <Box sx={{ width: "100%", ...sx }}>
            {!smallScreen ? (
                <>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs value={value} onChange={handleChange} {...props}>
                            {tabs.map((tab) => (
                                <Tab label={tab} key={tab} />
                            ))}
                        </Tabs>
                    </Box>

                    {children.map((child, index) => (
                        <TabContent value={value} index={index} key={index}>
                            {child}
                        </TabContent>
                    ))}
                </>
            ) : (
                // Mobile: Accordion
                <>
                    {children.map((child, index) => (
                        <Accordion
                            sx={{ backgroundColor: theme.palette.grey[100], mb: 1 }}
                            key={index}
                        >
                            <AccordionSummary expandIcon={<ExpandMore />} aria-controls={`panel-${index}`}
                                id={`panel-${index}-header`}>
                                <Typography sx={{ fontWeight: "bold" }}>{child.props.label}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>{child}</AccordionDetails>
                        </Accordion>
                    ))}
                </>
            )}
        </Box>
    );
}
